import React from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { InboxAdvancedFilters } from "@seabrookstudios/pitch2table-core";
import { useInboxAddress, useInboxMessages } from "@seabrookstudios/pitch2table";
import { IsMember, LockedBanner } from "../core/HasEntitlements";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";
import { NoItemsFound } from "../publisher/NoItemsFound";
import { AlwaysOnAppLink } from "../styleguide/AppLink";
import { Path } from "../Path";
import { InboxMessageDetailFromRoute } from "./DetailView";
import { InboxListHeader } from "./InboxListHeader";
import { InboxMessageListEntry } from "./ListEntry";

const NotFound = () => {
  const { data: address } = useInboxAddress();

  if (!address?.email) {
    return (
      <NoItemsFound>
        <Alert severity="warning">
          Capture publisher responses directly and link them to your publisher submission record. To use this feature
          you need to set up an inbox in the{" "}
          <AlwaysOnAppLink to={Path.settings().category("email-inbox")}>Email Inbox settings</AlwaysOnAppLink>.
        </Alert>
      </NoItemsFound>
    );
  }

  return (
    <NoItemsFound>
      <Alert severity="info">
        Publisher replies to your inbox address will appear here. Use that address when you email publishers.
      </Alert>
    </NoItemsFound>
  );
};

const InboxListAndDetailMembers = () => {
  const useMakeList = useMakeListBuilder(
    InboxMessageListEntry,
    idExtractor,
    "Inbox",
    NotFound,
    undefined,
    InboxListHeader
  );

  const ListAndDetail = useMakeListAndDetail(
    useInboxMessages,
    [],
    "inbox",
    useMakeList,
    InboxMessageDetailFromRoute,
    InboxAdvancedFilters
  );

  return <ListAndDetail />;
};

export const InboxListAndDetail = () => (
  <IsMember
    LockedView={
      <Box p={2}>
        <LockedBanner title="Inbox is a Premium feature. Upgrade to capture and file publisher emails." />
      </Box>
    }
  >
    <InboxListAndDetailMembers />
  </IsMember>
);
